import { captureException as baseCaptureException, captureMessage as baseCaptureMessage } from '@sentry/react';
import type { Primitive } from 'type-fest';

import { Codeowners } from '../../consts/codeowners';

export function captureException(
  error: unknown,
  codeOwners: Codeowners,
  tags?: Record<string, Primitive>,
  extra?: Record<string, unknown>
) {
  baseCaptureException(error, {
    tags: { codeowners: codeOwners, ...tags },
    extra,
  });

  return error;
}

export function captureMessage(
  message: string,
  codeOwners: Codeowners,
  tags?: Record<string, Primitive>,
  extra?: Record<string, unknown>
) {
  baseCaptureMessage(message, {
    tags: { codeowners: codeOwners, ...tags },
    extra,
  });

  return message;
}
